import { CaseAdmin } from "pwapi";

import { useSortedBlocks } from "shared/hooks/useSortedCase";

import HiddenDropDown from "../filters/HiddenDropdown";
import OrdersTable from "../ordersTable/OrdersTable";

type OrdersProps = {
  adminCase: CaseAdmin;
};

const Orders = ({ adminCase }: OrdersProps) => {
  const labOrders = adminCase.lab_orders || [];
  const blocks = useSortedBlocks(adminCase);
  const filteredBlocks = blocks.filter((block) =>
    labOrders.some((lab_order) =>
      lab_order.lab_order_items.some(
        (lab_order_item) => lab_order_item.block_id === block.id
      )
    )
  );
  const blocklessOrders = labOrders.filter((labOrder) => {
    const labOrderBlockIds = labOrder.lab_order_items.map(
      (labOrderItem) => labOrderItem.block_id
    );
    return (
      labOrderBlockIds.length > 0 &&
      !blocks.some((block) => labOrderBlockIds.includes(block.id))
    );
  });

  return (
    <div className="panelContainer panelContainer--gap">
      {filteredBlocks.map((block) => {
        return (
          <HiddenDropDown
            label={block.full_name}
            isInitOpen
            type="largeLabel"
            key={block.id}
          >
            <OrdersTable
              orders={labOrders.filter((labOrder) =>
                labOrder.lab_order_items.some(
                  (labOrderItem) => labOrderItem.block_id === block.id
                )
              )}
            />
          </HiddenDropDown>
        );
      })}
      {blocklessOrders.length > 0 && (
        <HiddenDropDown label="Undefined" isInitOpen type="largeLabel">
          <OrdersTable orders={blocklessOrders} />
        </HiddenDropDown>
      )}
    </div>
  );
};

export default Orders;
